import { ServiceOptions } from 'services/baseService';
import { RootState } from 'store/store';

export const selectTeamRosterFilters = (state: RootState): ServiceOptions => state.teamRosterFilter.options;

export const selectLimit = (state: RootState): number | undefined => state.teamRosterFilter.options.limit;

export const selectCurrentPage = (state: RootState): number => state.teamRosterFilter.currentPage;
